import { createContext, useContext } from 'react';
export const DetailsPageContext = /*#__PURE__*/createContext({
  appContext: 'app',
  displayTag: undefined,
  iconUrl: '',
  listingId: 0,
  listingIdV2: 0,
  // TODO - deprecate --- this is still needed for sendAdminEmail
  previewListingId: undefined,
  name: '',
  productType: 'APP',
  published: true,
  runLeadGen: () => {},
  trackInteraction: () => {},
  trackInstall: () => {},
  userInfo: {},
  isEmbedded: false
});
export const useDetailsPageContext = () => {
  const context = useContext(DetailsPageContext);
  if (!context) {
    throw new Error('useDetailsPageContext must be used within a DetailsPageContext.Provider');
  }
  return context;
};